<template>
  <Button class="c_asset_category_button" :class="[`c_asset_button--${theme}`]" v-bind="modifiedButtonOptions">
    <span>Data Sheet</span>
  </Button>
</template>

<script>
import Button from 'Components/button/Button.vue';

export default {
  components: {
    Button,
  },
  data() {
    return {};
  },
  props: {
    buttonOptions: {
      type: Object,
      default() {
        return {
          reset: true,
          unstyle: true,
        };
      },
    },
    href: { type: String, required: true },
    iconOptions: {
      type: Object,
      default() {
        return {
          handle: 'file_download',
        };
      },
    },
    labelText: String,
    theme: { type: String, default: 'black' },
  },
  computed: {
    modifiedButtonOptions() {
      const returnedButtonOptions = this.buttonOptions;
      returnedButtonOptions.href = this.href;
      return returnedButtonOptions;
    },
    modifiedIconOptions() {
      const returnedIconOptions = this.iconOptions;
      return returnedIconOptions;
    },
  },
};
</script>

<style lang="scss">
.c_asset_button {
  $self: &;

  // background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--asset-button-font-size, 1rem);
  color: var(--button-color, #{$color_black});
  text-decoration: none;

  @at-root #{$self}--black {
    --asset-button-font-size: px_to_rem(18);
    @include font('graphik_regular');
    line-height: px_to_rem(20);
    --button-color: #{$color_black};
  }

  @at-root #{$self}--red {
    --button-color: #{$color_black};
    &:hover {
      outline: 1.5px solid #ed000e;
      background-color: #fff;
      color: black;
    }
    &:focus {
      --button-color: #fff;
      background-color: #fff;
      border-color: #ed000e;
      border-style: 10px;
      color: black;
    }
    .c_box--gray_247 {
      --button-color: #{$color_red_179};
      &:hover,
      &:focus {
        --button-color: #{$color_red};
      }
    }
  }

  &:hover,
  &:focus {
    color: var(--button-color, #{$color_black});
  }

  @at-root #{$self}__icon {
    display: inline-block;
    width: auto;
    max-width: 100%;
    vertical-align: top; // aligns text to the top of the icon
    height: 17px;
    @include mq($mq_sm_to_md, '', 'rem') {
      height: 23px;
    }
    svg {
      width: auto;
      overflow: visible;
    }
  }
}
.c_asset_category_button {
  $self: &;

  background-color: white;
  border: 2px solid red;
  border-radius: 10px;
  height: 45px;
  width: 325px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--asset-button-font-size, 1rem);
  color: var(--button-color, #{$color_black});
  text-decoration: none;

  @at-root #{$self}--black {
    --asset-button-font-size: px_to_rem(18);
    @include font('graphik_regular');
    line-height: px_to_rem(20);
    --button-color: #{$color_black};
  }

  @at-root #{$self}--red {
    --button-color: #{$color_black};
    &:hover {
      // outline: 1.5px solid #ed000e;
      background-color: #fff;
      color: black;
    }
    &:focus {
      --button-color: #fff;
      background-color: #fff;
      border-color: #ed000e;
      border-style: 10px;
      color: black;
    }
    .c_box--gray_247 {
      --button-color: #{$color_red_179};
      &:hover,
      &:focus {
        --button-color: #{$color_red};
      }
    }
  }

  &:hover,
  &:focus {
    color: var(--button-color, #{$color_black});
  }
}
</style>
